import { makeObservable, observable } from 'mobx'

import Variable from './Variable'
import Dependency from './Dependency'
import Formula from './Formula'
import Settings from './Settings'

class KPI {
    clientId

    @observable kpiId

    @observable name

    @observable description

    @observable industry

    @observable productType

    @observable surveyType

    @observable respondentType

    @observable dependencies

    @observable variables

    @observable formula

    @observable minQlistQuestions

    @observable isHardcoded

    constructor({
        id = 0,
        kpiId,
        clientId = 1,
        name,
        description = '',
        industry,
        productType,
        surveyType,
        respondentType,
        settings = {},
        dependencies = [],
        variables = [],
        formula = [],
        minQlistQuestions = 0,
        isHardcoded = false,
    }) {
        this.id = id
        this.kpiId = kpiId
        this.clientId = clientId
        this.name = name
        this.description = description
        this.industry = industry
        this.productType = productType
        this.surveyType = surveyType
        this.respondentType = respondentType
        this.dependencies = dependencies.map((d) => new Dependency(d))
        this.variables = variables.map((v) => new Variable(v))
        this.formula = formula.map((f) => new Formula(f))
        this.settings = new Settings(settings)
        this.minQlistQuestions = !Number.isNaN(minQlistQuestions)
            ? parseInt(minQlistQuestions, 10)
            : 0
        this.isHardcoded = isHardcoded

        makeObservable(this)
    }

    toJSON() {
        return {
            id: this.id,
            kpiId: this.kpiId,
            clientId: this.clientId,
            isHardcoded: this.isHardcoded,
            name: this.name,
            description: this.description,
            industry: this.industry,
            productType: this.productType,
            surveyType: this.surveyType,
            respondentType: this.respondentType,
            dependencies: this.dependencies,
            settings: this.settings,
            variables: this.variables.slice().map((v) => v.toJSON()),
            formula: this.formula.slice().map((f) => f.toJSON()),
            minQlistQuestions: !Number.isNaN(this.minQlistQuestions)
                ? parseInt(this.minQlistQuestions, 10)
                : 0,
        }
    }
}

export default KPI
